export const Footer = () => (
  <footer className="footer-light">
    <div className="container-fluid container-xl px-4 px-lg-5">
      <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
        <div className="d-flex flex-wrap align-items-center gap-3 gap-md-4">
          <a href="https://www.shobdo.ai/about.html">About Us</a>
          <a href="https://www.shobdo.ai/values.html">Values</a>
          <a href="https://www.shobdo.ai/blog/">Blog</a>
          <a href="https://www.shobdo.ai/privacy.html">Privacy</a>
          <a href="https://www.shobdo.ai/terms.html">Terms</a>
          <address style={{ fontStyle: "normal" }}>
            <a href="mailto:support@shobdo.ai">support@shobdo.ai</a>
          </address>
        </div>
        <span className="footer-copy">
          &copy; <time dateTime="2026">2026</time> Shobdo, LLC
        </span>
      </div>
    </div>
  </footer>
);
